import { SxProps, Theme } from '@mui/material';
import { Icon } from '../Icon';

export const getScrollButtonComponent = (props: any) => {
  const isLeft = props.direction === 'left';
  const isDisabled = props.disabled;

  const boxShadow = isLeft
    ? '10px 0px 10px 0px rgba(0, 0, 0, 0.05)'
    : '-10px 0px 10px 0px rgba(0, 0, 0, 0.05)';

  return (
    <div
      className={[
        'flex items-center p-2',
        isDisabled ? 'text-Text/LightBackground/Disabled' : 'text-Primary/Main',
      ].join(' ')}
      style={{
        boxShadow: isDisabled ? 'none' : boxShadow,
      }}
      onClick={isDisabled ? () => undefined : props.onClick}
    >
      <Icon
        iconName={isLeft ? 'chevron-left' : 'chevron-right'}
        width={16}
        height={16}
      />
    </div>
  );
};

export const getTabIndicatorProps: React.HTMLAttributes<HTMLDivElement> & {
  sx?: SxProps<Theme>;
} = {
  style: {
    position: 'absolute',
    backgroundColor: '#009CE0',
    height: '2px',
    bottom: 0,
    transition: 'all 0.3s ease',
    borderRadius: '100px',
  },
};

export const getTabsClassName = (): string => {
  return 'w-fit';
};
